// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ActivityAvatar_avatar__7cIfi"};